import api from './index';

/**
 * Report Service
 * Fetches the client-safe free trademark report for an application
 * (GET /api/reports?applicationId=...). The backend enforces ownership and
 * only returns sent/draft reports — absence is a normal state, not an error.
 */
export const reportService = {
  /**
   * Get the report for an application. Returns null when no report exists.
   */
  getByApplicationId: async (applicationId) => {
    if (!applicationId) {
      return null;
    }

    try {
      const response = await api.get('/reports', {
        params: { applicationId }
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null;
      }
      console.error('Error fetching report by applicationId:', error);
      throw error;
    }
  }
};

export default reportService;
